import React, { useContext } from "react";
import {
	ResultsMenuCategoryContext,
	ResultsMenuStoreContext,
} from "@state/context/results";
import { ResultsMenuTournament } from "@data-types/results";
import ResultsTournamentItem from "./ResultsTournamentItem";

export default function ResultsTournamentList() {
	const store = useContext(ResultsMenuStoreContext);
	const category = useContext(ResultsMenuCategoryContext);

	if (!store.expandedCategories.has(category.id)) {
		return null;
	}

	return (
		<ul className="nav--quaternary">
			{category.children.map((tournament: ResultsMenuTournament) => {
				return (
					<ResultsTournamentItem
						key={tournament.id}
						tournament={tournament}
					/>
				);
			})}
		</ul>
	);
}
